/**
 * 操作日志 API
 */

import { http } from '../request';
import type { OperLog, OperLogListResponse, OperLogQueryParams } from '../../types/log';

/**
 * 分页查询操作日志
 */
export function getOperLogPage(params?: OperLogQueryParams): Promise<OperLogListResponse> {
  return http.get<OperLogListResponse>('/system/log/page', params);
}

/**
 * 删除操作日志
 */
export function deleteOperLogs(ids: number[]): Promise<void> {
  // 后端使用@RequestBody 接收 JSON 数组
  return http.delete('/system/log', {
    data: ids,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 清空操作日志
 */
export function clearOperLogs(): Promise<void> {
  return http.delete('/system/log/clear');
}
